import { FC, ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

export const TabPanel: FC<ITabPanel> = ({ value, activeValue, children, ...restProps }) => {
  return (
    <Box
      hidden={activeValue !== value}
      role='tabpanel'
      {...restProps}
      sx={[
        {
          height: '100%',
        },
        ...(Array.isArray(restProps.sx) ? restProps.sx : [restProps.sx]),
      ]}
    >
      {value === activeValue ? children : null}
    </Box>
  );
};

interface ITabPanel {
  value: string | number;
  activeValue: string | number;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}
